import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultEntityTypeImages = {};
export var EntityTypeImagesContext = React.createContext(defaultEntityTypeImages);
export var EntityTypeImagesProvider = createInheritedProvider(EntityTypeImagesContext);
// TODO - this could be wired to pull from a set of EntityTypes in the platform data
export var useEntityTypeImages = function () {
  return React.useContext(EntityTypeImagesContext);
};
export var useEntityTypeImage = function (entityTypeName) {
  var images = React.useContext(EntityTypeImagesContext);
  // this has no fallback, as icons are typically used as fallbacks here
  return images[entityTypeName];
};